import { Navigate, useLocation } from 'react-router-dom'
import AuthService from 'services/auth'

export default function BusinessRoute ({ children }) {
  const location = useLocation ()
  const isSigned = AuthService.isSigned ()
  const userType = AuthService.getUserType ()
  const canAccess = ['business', 'company', 'professional', 'admin'].includes (userType)

  if (isSigned && canAccess) {
    return children
  }

  return (
    <Navigate
      to='/login'
      state={{ from: location }}
      replace
    />
  )
}
